export class CustomerDesc {
    private desc: string|null;
    private error: string|null;

    constructor(desc: string|null, error: string|null) {
        this.setDesc(desc);
        this.setError(error);
    }

    setDesc(newDesc:string|null) {
        this.desc = newDesc;
    }
    setError(newError:string|null) {
        this.error = newError;
    }

    getDesc() {
        return this.desc;
    }
    getError() {
        return this.error;
    }
}

export async function getCustomerDesc(customerId:string):Promise<CustomerDesc> {
    try {
        const stripe = require('stripe')(`${process.env.REACT_APP_STRIPE}`);
        const customer = await stripe.customers.retrieve(customerId);

        var customerDesc = '';

        if (customer.name !== null && customer.name !== undefined && customer.name.length > 0) {
            customerDesc = customer.name;
        } else if (customer.email !== null && customer.email !== undefined && customer.email.length > 0) {
            customerDesc = customer.email;
        } else if (customer.id !== null && customer.id !== undefined && customer.id.length > 0) {
            customerDesc = customer.id;
        } else {
            customerDesc = '';
        }

        return new CustomerDesc(customerDesc, null);
    } catch (e) {
        return new CustomerDesc(null, e.message);
    }
}